import { useAccessor } from "~/client/contexts/Form/ProxyBank";

export default useAccessor;
